import { createApi } from '@reduxjs/toolkit/query/react';
import { City, County, State } from '@store/usTerritories/usTerritories.api';
import { baseQuery } from '@store/utils';

export interface OccurredIssue {
  id: number;
  coverage: number;
  account_last4: string;
  handled_at: string | null;
}

export interface Outage {
  state: State;
  county: County;
  city: City;
  duration: number;
  end_date: string;
  start_date: string;
  latitude: number;
  longitude: number;
  outage_count: number;
  outaged: boolean;
  tracked_count: number;
  utility: { id: number; name: string };
  zip_code: number;
  name?: string;
  occurred_issue: OccurredIssue | null;
}

interface RiskData {
  id: number;
  data: {
    event_happened: boolean;
    extra_expenses_confirmed: boolean;
    payment_requested: boolean;
  };
}
export const outagesApi = createApi({
  reducerPath: 'outages',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getOutages: builder.query<any, any>({
      query: () => ({
        url: `power_outage/`,
      }),
    }),
    getUserOutageStatuses: builder.query<Outage[], any>({
      query: () => ({
        url: `power_outage_status/`,
      }),
    }),
    handleOccurredIssue: builder.query<any, RiskData>({
      query: (payload) => ({
        url: `handle_occurred_issue/${payload.id}/`,
        method: 'PATCH',
        body: {
          ...payload.data,
        },
      }),
    }),
    getUserAlerts: builder.query<any, any>({
      query: () => ({
        url: `alerts/`,
      }),
    }),
    sendSupportEmail: builder.mutation<any, any>({
      query: (payload) => ({
        url: `support/email`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetOutagesQuery,
  useGetUserOutageStatusesQuery,
  useLazyHandleOccurredIssueQuery,
  useGetUserAlertsQuery,
  useSendSupportEmailMutation,
} = outagesApi;
